import { isSameDay, isSameMonth } from "date-fns";

import Day from "../Day";
import DayLabel from "../DayLabel";
import { CalendarComponentProps } from "../types";

import styles from "./Month.module.css";

type MonthProps = {
  days?: Date[];
  labels?: string[];
} & CalendarComponentProps;

const Month: React.FC<MonthProps> = ({
  days = [],
  labels = [],
  value,
  focused,
  onChange,
}) => {
  return (
    <div className={styles.root}>
      {labels.map((label, i) => (
        <DayLabel key={i}>{label}</DayLabel>
      ))}
      {days.map((day, i) => (
        <Day
          selected={value ? isSameDay(value, day) : false}
          key={i}
          date={day}
          blur={focused !== undefined && !isSameMonth(focused, day)} // Outside of current month
          onClick={onChange}
        />
      ))}
    </div>
  );
};

export default Month;
